import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'tisa-season-table-last-five-matches',
  templateUrl: './season-table-last-five-matches.component.html',
  styleUrls: ['./season-table-last-five-matches.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SeasonTableLastFiveMatchesComponent {
  private _circleColorClasses: string[] = [];

  @Input() set lastFiveMatches(matches: string[] | undefined) {
    this._circleColorClasses =
      matches?.map(match => this.getCircleColorClass(match)) ?? [];
  }

  get circleColorClasses(): string[] {
    return this._circleColorClasses;
  }

  private getCircleColorClass(match: string): string {
    switch (match) {
      case '1':
        return 'circle-won';
      case '0':
        return 'circle-draw';
      case '-1':
        return 'circle-lost';
      default:
        return '';
    }
  }
}
